import React from 'react';
import PropTypes from 'prop-types';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../../../../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../../../components/ui/dialog';

function DeleteApiKeyDialog({ isOpen, onClose, onConfirm, keyName }) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="h-5 w-5" />
            Delete API Key
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the API key{' '}
            <span className="font-medium text-foreground">&quot;{keyName}&quot;</span>? This action
            cannot be undone.
          </DialogDescription>
        </DialogHeader>

        <div className="p-3 bg-red-500/10 border border-red-500/20 rounded-lg">
          <p className="text-sm text-red-600">
            Any applications using this key will immediately lose access.
          </p>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Delete Key
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

DeleteApiKeyDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  keyName: PropTypes.string.isRequired,
};

export default DeleteApiKeyDialog;
